<template>
  <TheModal
    class="modal-card"
    v-model:show="showModalParam"
    scroll-target-class="card__body-content"
  >
    <div class="card__body modal__body height">
      <div class="modal__close desctop" @click="setShowProductModal(false)">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M5.33333 5.33398L26.6667 26.6673M26.6667 5.33398L5.33333 26.6673" stroke="white" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="modal__close tablet" @click="setShowProductModal(false)">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M4 4L20 20M20 4L4 20" stroke="black" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>
      </div>
      <TheProductContentDetail v-if="product" :key="product.product_id" class="card__body-wrapper" v-model:product="product"/>
    </div>
  </TheModal>
</template>

<script>
import TheModal from "@/components/TheModal.vue";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import TheProductImage from "@/components/element/TheProductImage.vue";
import TheProductTags from "@/components/element/TheProductTags.vue";
import ProductImageType from "@/enum/ProductImageType.js";
import TheNutritionProduct from "@/components/element/TheNutritionProduct.vue";
import TheProductSizes from "@/components/element/productBlock/TheProductSizes.vue";
import ProductType from "@/enum/ProductType.js";
import TheProductPlusAndMinusBox from "@/components/element/TheProductPlusAndMinusBox.vue";
import TheProductSupplements from "@/components/element/productBlock/TheProductSupplements.vue";
import TheProductSupplementsSelectedList from "@/components/element/productBlock/TheProductSupplementsSelectedList.vue";
import { reactive } from 'vue'
import TheProductContentDetail from "@/components/element/productBlock/TheProductContentDetail.vue";
export default {
  name: 'TheProductModal',
  components: {
    TheProductContentDetail,
    TheProductSupplementsSelectedList,
    TheProductSupplements,
    TheProductPlusAndMinusBox,
    TheProductSizes, TheNutritionProduct, TheProductTags, TheProductImage, TheModal
  },
  computed: {
    ProductImageType() {
      return ProductImageType
    },
    showModalParam: {
      get() {
        return this.isModalShow;
      },
      set() {
        this.setShowProductModal(false)
      }
    },
    ...mapState({
      'isMobile': state => state.isMobile,
      'product': state => state.productModal.product,
      'showModal': state => state.productModal.showModal,
    }),
    ...mapGetters({
      'isModalShow': 'productModal/isModalShow'
    }),
  },

  methods: {
    ...mapActions({
      'add': 'cart/add',
      'update': 'cart/update',
    }),
    ...mapMutations({
      'setShowProductModal': 'productModal/setShowProductModal',
    }),
  },

}
</script>

<style lang="scss" scoped>

</style>